import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared';
import { MrpJobTemplateToProcessOptionProcessTemplateLinkContainerModel } from '../../../../../../models/aggregates/mrp-process';


@Injectable({
  providedIn: 'root'
})
export class JobTemplateToProcessOptionProcessTemplateLinkService extends BaseApiTemplateService<MrpJobTemplateToProcessOptionProcessTemplateLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-job-template-to-process-option-process-template-link/backoffice-ep"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-job-template-to-process-option-process-template-link/backoffice-ep"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-job-template-to-process-option-process-template-link/backoffice-ep"
    this.httpClient = http;
  }

}
